import "./App.css";
import Main from "./Main";
import Footer from "./Footer";

function App() {
  return (
    <div className="App">
      <Main />
      <Footer />
    </div>
  );
}

export default App;
